module.exports = __webpack_public_path__ + "static/img/4.c5e3776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/在线教育/4.png
// module id = 5Oy+
// module chunks = 1